import { render } from "./CreateProfile.vue?vue&type=template&id=99c8362e&scoped=true"
import script from "./CreateProfile.vue?vue&type=script&lang=js"
export * from "./CreateProfile.vue?vue&type=script&lang=js"

import "./CreateProfile.vue?vue&type=style&index=0&id=99c8362e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99c8362e"]])

export default __exports__